<template>
  <main class="virtual_guard">
    <section
      v-if="getScreenOrientation() == 'landscape' && getIsTouch()"
      class="virtual_guard__container--landscape">
      <section
        class="virtual_guard__actions virtual_guard__section">
        <div class="virtual_guard__office virtual_guard__landscape_title">
          <span v-if="sublocation_info"><p>{{ sublocation_info.sublocation_name }}</p></span>
        </div>
        <VideoGuardProfile v-if="!onCall" 
          :connection_id="connection_id"
          @responseCall="responseCall()"
          :sublocation_info="sublocation_info"
          :sublocation_id="current_sublocation"></VideoGuardProfile>
        <VideoGuardCall
          :connection_id="connection_id"
          :current_sublocation="current_sublocation"
          @hangUp="hangUp()"
          v-else></VideoGuardCall>
      </section>
      <section
        class="virtual_guard__options virtual_guard__section max_2">
        <GeneralOptions v-if="!getShowPhonePrompt()"></GeneralOptions>
        <MissingCallOptions 
          v-else-if="getShowPhonePrompt()"
          :sublocation_id="current_sublocation"></MissingCallOptions>
        <PhoneIndex v-else-if="selected_option=='phone_index'"></PhoneIndex>
      </section>
      <div class="virtual_guard__dates virtual_guard__general_dates">
          <span :class="['virtual_guard__date', {'virtual_guard__date--blue': onCall}]">{{ date }}</span>
          <span :class="['virtual_guard__time', {'virtual_guard__date--blue': onCall}]">{{ time }}</span>
        </div>
    </section>
    <section 
      v-else
      class="virtual_guard__container">
      <div class="virtual_guard__office">
        <span v-if="sublocation_info"><p>{{ sublocation_info.sublocation_name }}</p></span>
      </div>
      <VideoGuardProfile v-if="!onCall" 
				:connection_id="connection_id"
        @responseCall="responseCall()"
				:sublocation_info="sublocation_info"
				:sublocation_id="current_sublocation"></VideoGuardProfile>
      <VideoGuardCall
        :connection_id="connection_id"
        :current_sublocation="current_sublocation"
        @hangUp="hangUp()"
        v-else></VideoGuardCall>
      <div class="virtual_guard__dates">
        <span :class="['virtual_guard__date', {'virtual_guard__date--blue': onCall}]">{{ date }}</span>
        <span :class="['virtual_guard__time', {'virtual_guard__date--blue': onCall}]">{{ time }}</span>
      </div>
    </section>
  </main>
</template>
<script>
import VideoGuardProfile from './components/VideoGuardProfile.vue';
import VideoGuardCall from "@/views/components/VideoGuardCall.vue";
import GeneralOptions from "@/components/options/GeneralOptions.vue";
import MissingCallOptions from "@/components/options/MissingCallOptions.vue";
import PhoneIndex from "@/components/options/PhoneIndex.vue";

export default {
  components: {
    VideoGuardCall,
    VideoGuardProfile,
    GeneralOptions,
    MissingCallOptions,
    PhoneIndex
  },
  data() {
    return {
      time: null,
      timerInterval: null,
      date: null,
      onCall: false,
      answering_call: null,
			current_sublocation: null,
			connection_id: '',
			sublocation_info: null,
      selected_option:"general"
    }
  },
  created() {
    this.updateIsTouch(this.$route.query.istouch)
    console.log("IsTouch!!!!")
    console.log(this.getIsTouch())
    this.generateDate();
		this.connection_id = this.buildDeviceId();
    if (this.$route.query.id && this.$route.query.id.includes('_')) {
      const params = this.$route.query.id.split('_');
      this.current_sublocation = params[0] ? params[0] : null;
      this.answering_call = params[1] ? params[0] : null;
    } else {
      this.current_sublocation = this.$route.query.id ? this.$route.query.id : null;
      this.answering_call = null;
    }
		if (this.current_sublocation !== null) {
			this.subscribeVirtualGuardChannel(this.current_sublocation);
		}
		this.getSublocationInfo();
  },
  mounted() {
    this.checkOrientation()
    window.addEventListener('orientationchange', this.checkOrientation)
    this.timerInterval = setInterval(() => {
      this.generateDate();
    }, 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  },
  methods: {
    checkOrientation(){
      const orientation = window.screen.orientation?.type
      if(orientation.startsWith('portrait') || window.innerHeight > window.innerWidth){
        this.updateScreenOrientation('portrait')
      }else{
        this.updateScreenOrientation('landscape')
      }
      console.log(this.getScreenOrientation())
    },
    generateDate() {
      const date = new Date();
      const auxTime = date.toLocaleString('es-ES', {hour: '2-digit', minute: '2-digit', hour12: true});
      this.date = date.toLocaleString('es-ES', {day: '2-digit', month: 'long', year: 'numeric'});
      this.time = auxTime.replace(/\./g, '').replace(/p\sm/g, 'pm')
    },
		subscribeVirtualGuardChannel(sublocation_id) {
			this.unsubscribeFromChannel();
			this.$cable.subscribe({
				channel: 'VirtualGuardChannel',
				room: `room_virtual_guard_${sublocation_id}`,
				sublocation_id,
			});
		},
		unsubscribeFromChannel() {
			this.$cable.unsubscribe("VirtualGuardChannel");
		},
		getSublocationInfo() {
			const vm = this;
			try {
				this.$http.get('digital_guard/sublocation_info', {
					params: {
						sublocation_id: this.current_sublocation,
					},
					headers: {
						'X-Device_ID': this.getDeviceId(),
					}
				}).then(response => {
					vm.sublocation_info = response.body.data;
				})
			} catch (err) {
				console.error(err);
				
			}
		},
    responseCall() {
      this.onCall = true;
    },
    hangUp() {
      this.onCall = false;
    }
  },
  channels: {
		VirtualGuardChannel: {
      received(data) {
        const connectionId = data.data.connection_id;
        if (connectionId !== this.connection_id) {
          if (data.data.answer_call === true && data.data.message === 'answerCall') {
            clearInterval(this.callInterval);
            this.responseCall();
          } else if (data.data.message === 'notifyCallEnded' && data.data.notify_call_ended === true) {
            this.hangUp();
          }
        }
      }
		}
  }
}
</script>